// src/App.tsx
import React, { Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { initializeIcons } from "@uifabric/icons";

import { initializeFeatures } from "utils/featureFlags";
import { registerCustomIcons } from "utils/icons";
import { usePrefetchContent } from "utils/requests";
import { EXPLORER_ENABLED } from "utils/constants";
import NotFound from "pages/NotFound";
import Layout from "./components/Layout";
import { RequestInterceptor } from "components/auth";
import { AUTH_ENABLED } from "utils/helpers/authConstants";
import LandingPage from "pages/Landing";
import { URLS } from "utils/constants";
import Settings from "pages/Settings";
import "styles/codefiles.css";
import JsonViewerPage from "pages/JsonViewer";
import { ToasterProvider } from "components/controls/toastNotification";

const Explore = React.lazy(() => import("pages/Explore"));
const Catalog = React.lazy(() => import("./pages/Catalog2"));
const CollectionDetailPage = React.lazy(() => import("pages/CollectionDetail"));
const OperationsPage = React.lazy(() => import("pages/Operations"));

function App() {
  initializeIcons(
    "https://res.cdn.office.net/files/fabric-cdn-prod_20240129.001/assets/icons/",
    { disableWarnings: true }
  );
  registerCustomIcons();
  initializeFeatures();
  usePrefetchContent();

  const pageFallback = (
    <Layout onGrid={false} isShort={true} allowAnnouncement={false}></Layout>
  );

  const { home, explorer, collections, operations, settings, json } = URLS;

  return (
    <ToasterProvider>
      <Router basename={process.env.PUBLIC_URL}>
        <RequestInterceptor enabled={AUTH_ENABLED}>
          <div>
            <Routes>
              <Route path={home} element={<LandingPage />} />
              <Route
                path={collections}
                element={
                  <Suspense fallback={pageFallback}>
                    <Catalog />
                  </Suspense>
                }
              />
              <Route path={settings} element={<Settings />} />
              <Route
                path={`/${collections}/:id`}
                element={
                  <Suspense fallback={pageFallback}>
                    <CollectionDetailPage />
                  </Suspense>
                }
              />
              {EXPLORER_ENABLED && (
                <Route
                  path={explorer}
                  element={
                    <Suspense fallback={pageFallback}>
                      <Explore />
                    </Suspense>
                  }
                />
              )}
              <Route path={json} element={<JsonViewerPage />} />
              <Route
                path={operations}
                element={
                  <Suspense fallback={pageFallback}>
                    <OperationsPage />
                  </Suspense>
                }
              />
              <Route path="/404" element={<NotFound />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </RequestInterceptor>
      </Router>
    </ToasterProvider>
  );
}

export default App;
